// App.js – ToastProvider + hamburger + eksiksiz SPC uygulaması
import React, { useState } from 'react';
import './App.css';
import { ProcessReportButton } from './components/ProcessReportButton';
import AnalysisPanel             from './components/AnalysisPanel';


/* ===== Chart.js + React ===== */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

/* ===== Blockchain yardımcıları ===== */
import { getContract, getSignerContract } from './contract';

/* ===== Yapay zeka yorum bileşeni ===== */
import GraphAI from './GraphAI';

/* ===== Toast ===== */
import { ToastProvider, useToast } from './components/ToastContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

/* ==================================================
 * ONDALIK DEĞER KATSAYISI
 * ================================================== */
const DECIMALS = 100;                 // 2 hane

/* ==================================================
 * SPC SABİTLERİ
 * ================================================== */
const spcConstantsXR = {
  2:{A2:1.880,D3:0,D4:3.267,d2:1.128},3:{A2:1.023,D3:0,D4:2.574,d2:1.693},
  4:{A2:0.729,D3:0,D4:2.282,d2:2.059},5:{A2:0.577,D3:0,D4:2.115,d2:2.326},
  6:{A2:0.483,D3:0,D4:2.004,d2:2.534},7:{A2:0.419,D3:0.076,D4:1.924,d2:2.704},
  8:{A2:0.373,D3:0.136,D4:1.864,d2:2.847},9:{A2:0.337,D3:0.184,D4:1.816,d2:2.970},
  10:{A2:0.308,D3:0.223,D4:1.777,d2:3.078},11:{A2:0.285,D3:0.256,D4:1.744,d2:3.173},
  12:{A2:0.266,D3:0.283,D4:1.717,d2:3.258},13:{A2:0.249,D3:0.307,D4:1.693,d2:3.336},
  14:{A2:0.235,D3:0.328,D4:1.672,d2:3.407},15:{A2:0.223,D3:0.347,D4:1.653,d2:3.472},
  16:{A2:0.212,D3:0.363,D4:1.637,d2:3.532},17:{A2:0.203,D3:0.378,D4:1.622,d2:3.588},
  18:{A2:0.194,D3:0.391,D4:1.608,d2:3.640},19:{A2:0.187,D3:0.403,D4:1.597,d2:3.689},
  20:{A2:0.180,D3:0.415,D4:1.585,d2:3.735},21:{A2:0.173,D3:0.425,D4:1.575,d2:3.778},
  22:{A2:0.167,D3:0.434,D4:1.566,d2:3.819},23:{A2:0.162,D3:0.443,D4:1.557,d2:3.858},
  24:{A2:0.157,D3:0.451,D4:1.548,d2:3.895},25:{A2:0.153,D3:0.459,D4:1.541,d2:3.931},
};

const spcConstantsXS = {
  2:{A3:2.659,B3:0,B4:3.267},3:{A3:1.954,B3:0,B4:2.568},4:{A3:1.628,B3:0,B4:2.266},
  5:{A3:1.427,B3:0,B4:2.089},6:{A3:1.287,B3:0,B4:1.970},7:{A3:1.182,B3:0.03,B4:1.882},
  8:{A3:1.099,B3:0.118,B4:1.815},9:{A3:1.032,B3:0.185,B4:1.761},
  10:{A3:0.975,B3:0.239,B4:1.716},11:{A3:0.927,B3:0.284,B4:1.679},
  12:{A3:0.886,B3:0.321,B4:1.646},13:{A3:0.850,B3:0.354,B4:1.618},
  14:{A3:0.817,B3:0.382,B4:1.593},15:{A3:0.789,B3:0.406,B4:1.572},
  16:{A3:0.763,B3:0.428,B4:1.553},17:{A3:0.739,B3:0.448,B4:1.536},
  18:{A3:0.718,B3:0.466,B4:1.522},19:{A3:0.698,B3:0.482,B4:1.509},
  20:{A3:0.680,B3:0.497,B4:1.497},21:{A3:0.663,B3:0.510,B4:1.487},
  22:{A3:0.647,B3:0.523,B4:1.477},23:{A3:0.633,B3:0.535,B4:1.468},
  24:{A3:0.619,B3:0.547,B4:1.460},25:{A3:0.606,B3:0.558,B4:1.453},
};

/* ==================================================
 * TEMEL İSTATİSTİK
 * ================================================== */
const mean  = (a) => a.reduce((x,y)=>x+y,0)/a.length;
const stdev = (a) => {
  if(a.length<=1) return 0;
  const m = mean(a);
  return Math.sqrt(a.reduce((s,v)=>s+(v-m)**2,0)/(a.length-1));
};

/* ==================================================
 * XR / XS / IMR HESAPLARI
 * ================================================== */
const computeXR = (pts)=>{
  if(!pts.length||pts[0].length<2) return null;
  const n = pts[0].length, c = spcConstantsXR[n];
  if(!c) return null;
  const xbars  = pts.map(mean);
  const ranges = pts.map((sg)=>Math.max(...sg)-Math.min(...sg));
  const xbarbar = mean(xbars), rbar = mean(ranges);
  return {
    xbars,ranges,xbarbar,rbar,
    uclXbar:xbarbar+c.A2*rbar,
    lclXbar:xbarbar-c.A2*rbar,
    uclR:c.D4*rbar,lclR:c.D3*rbar,
    sigma:rbar/c.d2,
  };
};

const computeXS = (pts)=>{
  if(!pts.length||pts[0].length<2) return null;
  const n = pts[0].length, c = spcConstantsXS[n];
  if(!c) return null;
  const xbars = pts.map(mean);
  const sVals = pts.map(stdev);
  const xbarbar=mean(xbars), sbar = mean(sVals);
  return {
    xbars,sValues:sVals,xbarbar,sbar,
    uclXbar:xbarbar+c.A3*sbar,lclXbar:xbarbar-c.A3*sbar,
    uclS:c.B4*sbar,lclS:c.B3*sbar,
    sigma:sbar,
  };
};

const computeIMR = (pts)=>{
  const individuals = pts.map((sg)=>sg[0]);
  const mr = individuals.slice(1).map((v,i)=>Math.abs(v-individuals[i]));
  const avgI = mean(individuals), avgMR = mean(mr);
  const E2 = 2.66, d2 = 1.128;
  return {
    individuals,movingRanges:mr,avgI,avgMR,
    UCL_I:avgI+E2*avgMR, LCL_I:avgI-E2*avgMR,
    sigma:avgMR/d2,
  };
};

/* ==================================================
 * ANA BİLEŞEN
 * ================================================== */
function InnerApp() {
  const toast = useToast();              // Toast kullan
  const [menuOpen,setMenuOpen]=useState(false);
  const toggleMenu=()=>setMenuOpen(!menuOpen);

  /* ---------- STATE ---------- */
  const [activePage,setActivePage]=useState('create');
  const [subject,setSubject]=useState('');
  const [description,setDescription]=useState('');
  const [measurementUnit,setMeasurementUnit]=useState('kg');
  const [exampleNo,setExampleNo]=useState(1);
  const [subGroups,setSubGroups]=useState([]);
  const [lsl,setLsl]=useState('');const [usl,setUsl]=useState('');
  const [createdMeasurementId,setCreatedMeasurementId]=useState(null);
  const [txHash,setTxHash]=useState(null);
  const [fetchId,setFetchId]=useState('');
  const [selectedChartType,setSelectedChartType]=useState('X-R');
  const [fetchedMeasurement,setFetchedMeasurement]=useState(null);
  const [myMeasurements,setMyMeasurements]=useState([]);
  const [contId,setContId]=useState('');
  const [contMeasurement,setContMeasurement]=useState(null);
  const [contGroupIdx,setContGroupIdx]=useState(null);
  const [contGroupVals,setContGroupVals]=useState([]);
  const [statusMessage,setStatusMessage]=useState('');

  /* ==================================================
   * ALT GRUP OLUŞTUR / EKLE / SİL
   * ================================================== */
  const handleGenerateSubgroups=()=>{
    const tmp=[];for(let i=0;i<exampleNo;i++) tmp.push([]);
    setSubGroups(tmp);
  };
  const handleAddDataPoint=(sgIdx)=>{
    const tmp=[...subGroups];tmp[sgIdx].push('');setSubGroups(tmp);
  };
  const handleRemoveDataPoint=(sgIdx,ptIdx)=>{
    const tmp=[...subGroups];tmp[sgIdx].splice(ptIdx,1);setSubGroups(tmp);
  };
  const handleDataPointChange=(sgIdx,ptIdx,val)=>{
    const tmp=[...subGroups];tmp[sgIdx][ptIdx]=val;setSubGroups(tmp);
  };

  /* ==================================================
   * CONTINUE – alt grup satırı
   * ================================================== */
  const handleAddContPoint=()=>setContGroupVals([...contGroupVals,'']);
  const handleRemoveContPoint=(i)=>{
    const t=[...contGroupVals];t.splice(i,1);setContGroupVals(t);
  };
  const handleContValChange=(i,v)=>{
    const t=[...contGroupVals];t[i]=v;setContGroupVals(t);
  };

  /* ==================================================
   * CREATE MEASUREMENT
   * ================================================== */
  const handleCreateMeasurement = async () => {
    try {
      // Başlangıçta UIʼı sıfırla ve kullanıcıyı bilgilendir
      toast.info('MetaMask onayı bekleniyor…');
      setStatusMessage('SPC ölçümü oluşturuluyor, lütfen MetaMask onayını bekleyin…');
      setCreatedMeasurementId(null);
      setTxHash(null);
  
      // 1) LSL ve USL değerlerini DECIMALS ile ölçekle
      const safeLsl = parseInt((parseFloat(lsl || '0') * DECIMALS).toString());
      const safeUsl = parseInt((parseFloat(usl || '0') * DECIMALS).toString());
  
      // 2) Alt grupları sayısal dizi haline getir
      const numericSubGroups = subGroups.map(sg =>
        sg.map(v => parseInt((parseFloat(v || '0') * DECIMALS).toString()))
      );
  
      // 3) Sözleşme çağrısı
      const signerContract = await getSignerContract();
      const tx = await signerContract.createMeasurement(
        subject,
        description,
        measurementUnit,
        numericSubGroups,
        safeLsl,
        safeUsl
      );
  
      // 4) İşlemi bekle ve tx hashʼi kaydet
      setStatusMessage('Transaction onaylanıyor, lütfen bekleyin…');
      const receipt = await tx.wait();
      if (receipt.transactionHash) setTxHash(receipt.transactionHash);
      if (receipt.status === 0) {
        toast.error('Transaction revert oldu!');
        setStatusMessage('Transaction başarısız.');
        return;
      }
  
      // 5) Eventʼten ID alma denemesi
      let newId = null;
      const ev = receipt.events?.find(e => e.event === 'MeasurementCreated');
      if (ev) {
        newId = ev.args[0].toString();
      }
  
      // 6) Log decode ile yedek ID alma
      if (!newId) {
        const parsed = receipt.logs
          .map(log => {
            try { return signerContract.interface.parseLog(log); }
            catch { return null; }
          })
          .find(x => x && x.name === 'MeasurementCreated');
        if (parsed) newId = parsed.args[0].toString();
      }
  
      // 7) Fallback: en son IDʼyi al
      if (!newId) {
        const ids = await signerContract.getMyMeasurementIds();
        if (ids.length) {
          newId = ids[ids.length - 1].toString();
        }
      }
  
      // 8) Sonucu UIʼa yazdır
      if (newId) {
        setCreatedMeasurementId(newId);
        toast.success(`Measurement oluşturuldu (#${newId})`);
        setStatusMessage(`Measurement oluşturuldu. ID = ${newId}`);
      } else {
        toast.error('Eventten ID alınamadı ve fallback de başarısız oldu.');
        setStatusMessage('Oluşturulan ölçümün ID’si alınamadı.');
      }
    } catch (err) {
      console.error(err);
      toast.error('SPC oluşturulurken hata!');
      setStatusMessage('SPC oluşturulurken hata oluştu.');
    }
  };
  

  /* ==================================================
   * UPDATE SUBGROUP (fetch & save)
   * ================================================== */
  const handleFetchForContinue=async()=>{
    try{
      if(!contId){toast.info('Geçerli ID girin!');return;}
      setStatusMessage('Veri çekiliyor...');
      const contract=getContract();
      const d=await contract.getMeasurement(contId);
      const scaled=d[4].map((sg)=>sg.map((v)=>parseFloat(v.toString())/DECIMALS));
      setContMeasurement({
        id:d[0].toString(),subject:d[1],description:d[2],
        measurementUnit:d[3],dataPoints:scaled,
        lsl:parseFloat(d[5])/DECIMALS,usl:parseFloat(d[6])/DECIMALS,owner:d[7],
      });
      toast.success(`Measurement #${d[0]} getirildi`);
      setContGroupIdx(null);setContGroupVals([]);
      setStatusMessage(`Measurement #${d[0]} getirildi.`);
    }catch(err){
      console.error(err);
      toast.error('Measurement bulunamadı!');
      setStatusMessage('Veri getirilirken hata.');
    }
  };

  const handleSaveSubgroup=async()=>{
    try{
      if(contGroupIdx===null){toast.info('Alt grup seçiniz!');return;}
      const numeric=contGroupVals.map((v)=>parseInt(String(parseFloat(v||'0')*DECIMALS)));
      const signer=await getSignerContract();
      const tx=await signer.updateSubgroup(contId,contGroupIdx,numeric);
      toast.info('Alt grup kaydediliyor…');
      setStatusMessage('Alt grup kaydediliyor, lütfen onaylayın...');
      await tx.wait();
      toast.success(`Alt grup #${contGroupIdx+1} kaydedildi!`);
      setStatusMessage(`Alt grup #${contGroupIdx+1} kaydedildi!`);
      await handleFetchForContinue();
    }catch(err){
      console.error(err);
      toast.error('Alt grup kaydedilirken hata!');
      setStatusMessage('Alt grup kaydedilirken hata.');
    }
  };

  /* ==================================================
   * GET MEASUREMENT (chart sayfası)
   * ================================================== */
  const handleFetchMeasurement=async()=>{
    try{
      if(!fetchId){toast.info('Geçerli ID girin!');return;}
      setStatusMessage('Veri çekiliyor...');
      const contract=getContract();
      const data=await contract.getMeasurement(fetchId);
      const rawLSL=parseFloat(data[5].toString());
      const rawUSL=parseFloat(data[6].toString());
      const scaledDP=data[4].map((sg)=>sg.map((v)=>parseFloat(v.toString())/DECIMALS));
      const m={
        id:data[0].toString(),subject:data[1],description:data[2],
        measurementUnit:data[3],dataPoints:scaledDP,
        lsl:rawLSL/DECIMALS,usl:rawUSL/DECIMALS,owner:data[7],
      };
      setFetchedMeasurement(m);
      toast.success(`Measurement #${m.id} getirildi`);
      setStatusMessage(`Measurement ID ${m.id} başarıyla getirildi!`);
    }catch(err){
      console.error(err);
      toast.error('Measurement getirilemedi!');
      setFetchedMeasurement(null);
      setStatusMessage('Measurement getirilirken hata oluştu.');
    }
  };

  /* ==================================================
   * PROFİL
   * ================================================== */
  const handleFetchMyMeasurements=async()=>{
    try{
      toast.info('Profil verileri çekiliyor…');
      setStatusMessage('Profil verileri getiriliyor...');
      const signer=getSignerContract();
      const ids=await (await signer).getMyMeasurementIds();
      const idNums=ids.map((bn)=>Number(bn.toString()));
      const out=[];const readOnly=getContract();
      for(const mid of idNums){
        const d=await readOnly.getMeasurement(mid);
        const rawLSL=parseFloat(d[5].toString()), rawUSL=parseFloat(d[6].toString());
        const sDP=d[4].map((sg)=>sg.map((v)=>parseFloat(v.toString())/DECIMALS));
        out.push({
          id:d[0].toString(),subject:d[1],description:d[2],measurementUnit:d[3],
          dataPoints:sDP,lsl:rawLSL/DECIMALS,usl:rawUSL/DECIMALS,owner:d[7],
        });
      }
      setMyMeasurements(out);
      toast.success('Profil verileri çekildi');
      setStatusMessage('Profil verileri başarıyla çekildi.');
    }catch(err){
      console.error(err);
      toast.error('Profil verileri getirilemedi!');
      setStatusMessage('Profil verileri getirilirken hata oluştu.');
    }
  };

  /* ==================================================
   * CHART RENDER + AI Entegrasyonu
   * ================================================== */
  const renderChart = () => {
    if (!fetchedMeasurement) return null;
    const { dataPoints, lsl, usl, measurementUnit } = fetchedMeasurement;
    if (!dataPoints.length) return null;

    const lslNum = Number(lsl);
    const uslNum = Number(usl);

    const computeCapability = (lsl, usl, meanVal, sigma) => {
      if (!sigma || sigma <= 0) return { cp: null, cpk: null };
      const cp = (usl - lsl) / (6 * sigma);
      const cpkLower = (meanVal - lsl) / (3 * sigma);
      const cpkUpper = (usl - meanVal) / (3 * sigma);
      return { cp, cpk: Math.min(cpkLower, cpkUpper) };
    };

    /* ================= X-R ================= */
    if (selectedChartType === 'X-R') {
      const resultXR = computeXR(dataPoints);
      if (!resultXR) {
        return <p>X-R hesaplaması için alt grup örnek boyutu en az 2 olmalı.</p>;
      }
      const {
        xbars,
        ranges,
        xbarbar,
        rbar,
        uclXbar,
        lclXbar,
        uclR,
        lclR,
        sigma,
      } = resultXR;

      const outOfControlX = xbars
        .map((v, idx) => (v > uclXbar || v < lclXbar ? idx + 1 : null))
        .filter(Boolean);
      const outOfControlR = ranges
        .map((v, idx) => (v > uclR || v < lclR ? idx + 1 : null))
        .filter(Boolean);

      const { cp, cpk } = computeCapability(lslNum, uslNum, xbarbar, sigma);
      const outCount = outOfControlX.length + outOfControlR.length;
      document.dispatchEvent(new CustomEvent('GRAPH_READY',{
        detail:{ xbars, mu:xbarbar, sigma, lsl:lslNum, usl:uslNum }
        }));

      const xbarData = {
        labels: xbars.map((_, i) => `Subgroup ${i + 1}`),
        datasets: [
          {
            label: 'Xbar',
            data: xbars,
            borderColor: '#FF6384',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderWidth: 2,
          },
          {
            label: 'UCL',
            data: xbars.map(() => uclXbar),
            borderDash: [5, 5],
            borderColor: '#36A2EB',
            backgroundColor: 'rgba(54,162,235,0.2)',
          },
          {
            label: 'LCL',
            data: xbars.map(() => lclXbar),
            borderDash: [5, 5],
            borderColor: '#FFCE56',
            backgroundColor: 'rgba(255,206,86,0.2)',
          },
          {
            label: 'Center',
            data: xbars.map(() => xbarbar),
            borderDash: [2, 2],
            borderColor: '#4BC0C0',
            backgroundColor: 'rgba(75,192,192,0.2)',
          },
          {
            label: 'LSL',
            data: xbars.map(() => lslNum),
            borderDash: [3, 3],
            borderColor: '#000',
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
          {
            label: 'USL',
            data: xbars.map(() => uslNum),
            borderDash: [3, 3],
            borderColor: '#000',
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
        ],
      };

      const rData = {
        labels: ranges.map((_, i) => `Subgroup ${i + 1}`),
        datasets: [
          {
            label: 'Range',
            data: ranges,
            borderColor: '#9966FF',
            backgroundColor: 'rgba(153,102,255,0.2)',
            borderWidth: 2,
          },
          {
            label: 'UCL',
            data: ranges.map(() => uclR),
            borderDash: [5, 5],
            borderColor: '#FF6384',
            backgroundColor: 'rgba(255,99,132,0.2)',
          },
          {
            label: 'LCL',
            data: ranges.map(() => lclR),
            borderDash: [5, 5],
            borderColor: '#36A2EB',
            backgroundColor: 'rgba(54,162,235,0.2)',
          },
          {
            label: 'Center (Rbar)',
            data: ranges.map(() => rbar),
            borderDash: [2, 2],
            borderColor: '#4BC0C0',
            backgroundColor: 'rgba(75,192,192,0.2)',
          },
        ],
      };

      return (
        <div>
          <h3>X-R Grafiği</h3>

          <div className="chart-container">
            <h4>Xbar Chart</h4>
            <Line data={xbarData} />
          </div>

          <div className="chart-container">
            <h4>R Chart</h4>
            <Line data={rData} />
          </div>

          <p>
            Kontrol dışı Xbar alt grup(lar):{' '}
            {outOfControlX.length ? outOfControlX.join(', ') : 'Yok'}
          </p>
          <p>
            Kontrol dışı R alt grup(lar):{' '}
            {outOfControlR.length ? outOfControlR.join(', ') : 'Yok'}
          </p>

          {cp !== null && (
            <div style={{ marginTop: '10px' }}>
              <h4>Proses Yeterlilik (Capability)</h4>
              <p>
                LSL: {lslNum} {measurementUnit}, USL: {uslNum} {measurementUnit}
              </p>
              <p>Sigma (tahmini): {sigma.toFixed(3)}</p>
              <p>
                Cp: {cp.toFixed(3)} Cpk: {cpk.toFixed(3)}
              </p>
            </div>
          )}

          <GraphAI
            analysisData={{
              cp: cp ?? 0,
              cpk: cpk ?? 0,
              outCount,
              xbars,
            }}
          />
        </div>
      );
    }

    /* ================= X-S ================= */
    else if (selectedChartType === 'X-S') {
      const resultXS = computeXS(dataPoints);
      if (!resultXS) {
        return <p>X-S hesaplaması için alt grup örnek boyutu en az 2 olmalı.</p>;
      }
      const {
        xbars,
        sValues,
        xbarbar,
        sbar,
        uclXbar,
        lclXbar,
        uclS,
        lclS,
        sigma,
      } = resultXS;

      const outOfControlX = xbars
        .map((v, idx) => (v > uclXbar || v < lclXbar ? idx + 1 : null))
        .filter(Boolean);
      const outOfControlS = sValues
        .map((v, idx) => (v > uclS || v < lclS ? idx + 1 : null))
        .filter(Boolean);

      const { cp, cpk } = computeCapability(lslNum, uslNum, xbarbar, sigma);
      const outCount = outOfControlX.length + outOfControlS.length;
      document.dispatchEvent(new CustomEvent('GRAPH_READY',{
        detail:{ xbars, mu:xbarbar, sigma, lsl:lslNum, usl:uslNum }
        }));
         

      const xbarData = {
        labels: xbars.map((_, i) => `Subgroup ${i + 1}`),
        datasets: [
          {
            label: 'Xbar',
            data: xbars,
            borderColor: '#FF6384',
            backgroundColor: 'rgba(255,99,132,0.2)',
          },
          {
            label: 'UCL',
            data: xbars.map(() => uclXbar),
            borderDash: [5, 5],
            borderColor: '#36A2EB',
            backgroundColor: 'rgba(54,162,235,0.2)',
          },
          {
            label: 'LCL',
            data: xbars.map(() => lclXbar),
            borderDash: [5, 5],
            borderColor: '#FFCE56',
            backgroundColor: 'rgba(255,206,86,0.2)',
          },
          {
            label: 'Center',
            data: xbars.map(() => xbarbar),
            borderDash: [2, 2],
            borderColor: '#4BC0C0',
            backgroundColor: 'rgba(75,192,192,0.2)',
          },
          {
            label: 'LSL',
            data: xbars.map(() => lslNum),
            borderDash: [3, 3],
            borderColor: '#000',
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
          {
            label: 'USL',
            data: xbars.map(() => uslNum),
            borderDash: [3, 3],
            borderColor: '#000',
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
        ],
      };

      const sData = {
        labels: sValues.map((_, i) => `Subgroup ${i + 1}`),
        datasets: [
          {
            label: 'S',
            data: sValues,
            borderColor: '#9966FF',
            backgroundColor: 'rgba(153,102,255,0.2)',
          },
          {
            label: 'UCL',
            data: sValues.map(() => uclS),
            borderDash: [5, 5],
            borderColor: '#FF6384',
            backgroundColor: 'rgba(255,99,132,0.2)',
          },
          {
            label: 'LCL',
            data: sValues.map(() => lclS),
            borderDash: [5, 5],
            borderColor: '#36A2EB',
            backgroundColor: 'rgba(54,162,235,0.2)',
          },
          {
            label: 'Center (Sbar)',
            data: sValues.map(() => sbar),
            borderDash: [2, 2],
            borderColor: '#4BC0C0',
            backgroundColor: 'rgba(75,192,192,0.2)',
          },
        ],
      };

      return (
        <div>
          <h3>X-S Grafiği</h3>

          <div className="chart-container">
            <h4>Xbar Chart</h4>
            <Line data={xbarData} />
          </div>

          <div className="chart-container">
            <h4>S Chart</h4>
            <Line data={sData} />
          </div>

          <p>
            Kontrol dışı Xbar alt grup(lar):{' '}
            {outOfControlX.length ? outOfControlX.join(', ') : 'Yok'}
          </p>
          <p>
            Kontrol dışı S alt grup(lar):{' '}
            {outOfControlS.length ? outOfControlS.join(', ') : 'Yok'}
          </p>

          {cp !== null && (
            <div style={{ marginTop: '10px' }}>
              <h4>Proses Yeterlilik (Capability)</h4>
              <p>
                LSL: {lslNum} {measurementUnit}, USL: {uslNum}{' '}
                {measurementUnit}
              </p>
              <p>Sigma (tahmini): {sigma.toFixed(3)}</p>
              <p>
                Cp: {cp.toFixed(3)} Cpk: {cpk.toFixed(3)}
              </p>
            </div>
          )}

          <GraphAI
            analysisData={{
              cp: cp ?? 0,
              cpk: cpk ?? 0,
              outCount,
              xbars,
            }}
          />
        </div>
      );
    }

    /* ================= I-MR ================= */
    else if (selectedChartType === 'I-MR') {
      const resultIMR = computeIMR(dataPoints);
      const {
        individuals,
        movingRanges,
        avgI,
        avgMR,
        UCL_I,
        LCL_I,
        sigma,
      } = resultIMR || {};
      if (!individuals) {
        return <p>I-MR hesaplamasında veri hatası!</p>;
      }

      const outOfControlI = individuals
        .map((v, idx) => (v > UCL_I || v < LCL_I ? idx + 1 : null))
        .filter(Boolean);

      const { cp, cpk } = computeCapability(lslNum, uslNum, avgI, sigma);
      const outCount = outOfControlI.length;
      document.dispatchEvent(new CustomEvent('GRAPH_READY',{
        detail:{ xbars:individuals, mu:avgI, sigma, lsl:lslNum, usl:uslNum }
        }));

      const iData = {
        labels: individuals.map((_, i) => `Point ${i + 1}`),
        datasets: [
          {
            label: 'Individuals',
            data: individuals,
            borderColor: '#FF6384',
            backgroundColor: 'rgba(255,99,132,0.2)',
          },
          {
            label: 'UCL',
            data: individuals.map(() => UCL_I),
            borderDash: [5, 5],
            borderColor: '#36A2EB',
            backgroundColor: 'rgba(54,162,235,0.2)',
          },
          {
            label: 'LCL',
            data: individuals.map(() => LCL_I),
            borderDash: [5, 5],
            borderColor: '#FFCE56',
            backgroundColor: 'rgba(255,206,86,0.2)',
          },
          {
            label: 'Center',
            data: individuals.map(() => avgI),
            borderDash: [2, 2],
            borderColor: '#4BC0C0',
            backgroundColor: 'rgba(75,192,192,0.2)',
          },
          {
            label: 'LSL',
            data: individuals.map(() => lslNum),
            borderDash: [3, 3],
            borderColor: '#000',
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
          {
            label: 'USL',
            data: individuals.map(() => uslNum),
            borderDash: [3, 3],
            borderColor: '#000',
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
        ],
      };

      const mrData = {
        labels: movingRanges.map((_, i) => `MR ${i + 1}`),
        datasets: [
          {
            label: 'MR',
            data: movingRanges,
            borderColor: '#9966FF',
            backgroundColor: 'rgba(153,102,255,0.2)',
          },
          {
            label: 'Center (MR Avg)',
            data: movingRanges.map(() => avgMR),
            borderDash: [2, 2],
            borderColor: '#4BC0C0',
            backgroundColor: 'rgba(75,192,192,0.2)',
          },
        ],
      };

      return (
        <div>
          <h3>I-MR Grafiği</h3>

          <div className="chart-container">
            <h4>I Chart</h4>
            <Line data={iData} />
          </div>

          <div className="chart-container">
            <h4>MR Chart</h4>
            <Line data={mrData} />
          </div>

          <p>
            Kontrol dışı bireysel noktalar:{' '}
            {outOfControlI.length ? outOfControlI.join(', ') : 'Yok'}
          </p>

          {cp !== null && (
            <div style={{ marginTop: '10px' }}>
              <h4>Proses Yeterlilik (Capability)</h4>
              <p>
                LSL: {lslNum} {measurementUnit}, USL: {uslNum}{' '}
                {measurementUnit}
              </p>
              <p>Sigma (tahmini): {sigma.toFixed(3)}</p>
              <p>
                Cp: {cp.toFixed(3)} Cpk: {cpk.toFixed(3)}
              </p>
            </div>
          )}

          <GraphAI
            analysisData={{
              cp: cp ?? 0,
              cpk: cpk ?? 0,
              outCount,
              xbars: individuals,
            }}
          />
        </div>
      );
    }

    return <p>Bu grafiğe ait hesaplama tanımlı değil.</p>;
  };

  /* ==================================================
   * RENDER RETURN
   * ================================================== */
  return(
    <div className={`app ${menuOpen?'menu-open':''}`}>
      {/* ----- HAMBURGER ----- */}
      <button className="hamburger" onClick={toggleMenu}>
        <span/><span/><span/>
      </button>

      {/* ----- SIDEBAR ----- */}
      <div className="sidebar" onClick={()=>setMenuOpen(false)}>
        <ul>
          <li onClick={()=>setActivePage('create')}   className={activePage==='create'?'active':''}>SPC Yap</li>
          <li onClick={()=>setActivePage('continue')} className={activePage==='continue'?'active':''}>SPC Devam Ettir</li>
          <li onClick={()=>setActivePage('chart')}    className={activePage==='chart'?'active':''}>Grafiği Getir</li>
          <li onClick={()=>setActivePage('analysis')} className={activePage==='analysis'?'active':''}>Analiz</li>   {/* NEW */}
          <li onClick={()=>setActivePage('profile')}  className={activePage==='profile'?'active':''}>Benim Ölçümlerim</li>
        </ul>
      </div>

      {/* ----- CONTENT ----- */}
      <div className="content">
        {/* ===== CREATE PAGE ===== */}
        {activePage==='create'&&(
          <div className="section">
            <h2>Yeni Ölçüm (Measurement) Oluştur</h2>
            <div><label>Konu:</label><input type="text" value={subject} onChange={(e)=>setSubject(e.target.value)}/></div>
            <div><label>Açıklama:</label><input type="text" value={description} onChange={(e)=>setDescription(e.target.value)}/></div>
            <div><label>Birim:</label>
              <select value={measurementUnit} onChange={(e)=>setMeasurementUnit(e.target.value)}>
                <option value="kg">kg</option><option value="gr">gr</option><option value="sn">sn</option>
                <option value="dk">dk</option><option value="cm">cm</option><option value="mm">mm</option>
              </select>
            </div>
            <div style={{marginTop:'10px'}}>
              <label>LSL:</label><input type="number" step="any" value={lsl} onChange={(e)=>setLsl(e.target.value)}/>
              <label style={{marginLeft:'20px'}}>USL:</label><input type="number" step="any" value={usl} onChange={(e)=>setUsl(e.target.value)}/>
            </div>
            <div style={{marginTop:'10px'}}>
              <label>Alt Grup Sayısı:</label>
              <input type="number" value={exampleNo} onChange={(e)=>setExampleNo(e.target.value)} style={{marginLeft:'10px'}}/>
              <button onClick={handleGenerateSubgroups} style={{marginLeft:'10px'}}>Alt Grupları Oluştur</button>
            </div>

            {/* Alt grup girişleri */}
            {subGroups.length>0&&(
              <div style={{marginTop:'15px'}}>
                <h3>Alt Gruplar</h3>
                {subGroups.map((sg,idx)=>(
                  <div key={idx} style={{border:'1px dashed #aaa',padding:'10px',margin:'5px 0'}}>
                    <h4>Örnek {idx+1}</h4>
                    {sg.map((val,p)=>(
                      <div key={p} style={{marginBottom:'5px'}}>
                        <label>Ölçüm {p+1}:</label>
                        <input type="number" step="any" value={val}
                          onChange={(e)=>handleDataPointChange(idx,p,e.target.value)}
                          style={{marginLeft:'10px'}}/>
                        <button onClick={()=>handleRemoveDataPoint(idx,p)} style={{marginLeft:'10px',color:'red'}}>Sil</button>
                      </div>
                    ))}
                    <button onClick={()=>handleAddDataPoint(idx)}>+ Veri Ekle</button>
                  </div>
                ))}
              </div>
            )}

            <button onClick={handleCreateMeasurement} style={{marginTop:'15px'}}>SPC Yap (Kaydet)</button>
            {createdMeasurementId&&<p style={{marginTop:'10px'}}><strong>ID:</strong> {createdMeasurementId}</p>}
            {txHash&&<p><strong>Tx Hash:</strong> {txHash}</p>}
          </div>
        )}

        {/* ===== CONTINUE PAGE ===== */}
        {activePage==='continue'&&(
          <div className="section">
            <h2>SPC Devam Ettir</h2>
            <div><label>ID:</label>
              <input type="number" value={contId} onChange={(e)=>setContId(e.target.value)} style={{marginLeft:'10px'}}/>
              <button onClick={handleFetchForContinue} style={{marginLeft:'10px'}}>Getir</button>
            </div>

            {contMeasurement&&(
              <div style={{marginTop:'20px'}}>
                <p><strong>Konu:</strong> {contMeasurement.subject}</p>
                <p><strong>Alt Grup Sayısı:</strong> {contMeasurement.dataPoints.length}</p>
                <h4>Alt Grup Durumu</h4>
                <ul>
                  {contMeasurement.dataPoints.map((sg,idx)=>(
                    <li key={idx}>
                      Alt Grup {idx+1}: {sg.length?`${sg.length} ölçüm`:'Boş'}
                      {!sg.length&&<button onClick={()=>{setContGroupIdx(idx);setContGroupVals([]);}} style={{marginLeft:'10px'}}>Seç</button>}
                    </li>
                  ))}
                </ul>

                {contGroupIdx!==null&&(
                  <div style={{marginTop:'20px',padding:'10px',border:'1px solid #aaa'}}>
                    <h4>Alt Grup {contGroupIdx+1} Veri Girişi</h4>
                    {contGroupVals.map((v,i)=>(
                      <div key={i} style={{marginBottom:'5px'}}>
                        <label>Ölçüm {i+1}:</label>
                        <input type="number" step="any" value={v} onChange={(e)=>handleContValChange(i,e.target.value)} style={{marginLeft:'10px'}}/>
                        <button onClick={()=>handleRemoveContPoint(i)} style={{marginLeft:'10px',color:'red'}}>Sil</button>
                      </div>
                    ))}
                    <button onClick={handleAddContPoint}>+ Veri Ekle</button>
                    <button onClick={handleSaveSubgroup} style={{marginLeft:'10px'}}>Kaydet</button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* ===== CHART PAGE ===== */}
        {activePage==='chart'&&(
          <div className="section">
            <h2>Grafik Getir</h2>
            <div><label>ID:</label>
              <input type="number" value={fetchId} onChange={(e)=>setFetchId(e.target.value)} style={{marginLeft:'10px'}}/>
            </div>
            <div><label>Grafik Tipi:</label>
              <select value={selectedChartType} onChange={(e)=>setSelectedChartType(e.target.value)} style={{marginLeft:'10px'}}>
                <option value="X-R">X-R</option><option value="X-S">X-S</option><option value="I-MR">I-MR</option>
              </select>
            </div>
            <button onClick={handleFetchMeasurement} style={{marginTop:'10px'}}>Grafiği Getir</button>

            {fetchedMeasurement&&(
              <div style={{marginTop:'20px'}}>
                <p><strong>Konu:</strong> {fetchedMeasurement.subject}</p>
                <p><strong>Açıklama:</strong> {fetchedMeasurement.description}</p>
                <p><strong>Birim:</strong> {fetchedMeasurement.measurementUnit}</p>
                <p><strong>LSL:</strong> {fetchedMeasurement.lsl} – <strong>USL:</strong> {fetchedMeasurement.usl}</p>
                <p><strong>Sahibi:</strong> {fetchedMeasurement.owner}</p>
        
                {renderChart()}
              </div>
            )}
          </div>
        )}

        {/* ===== PROFILE PAGE ===== */}
        {activePage==='profile'&&(
          <div className="section">
            <h2>Profil</h2>
            <button onClick={handleFetchMyMeasurements}>Benim Ölçümlerim</button>
            {myMeasurements.length>0&&(
              <div style={{marginTop:'20px'}}>
                <h3>Oluşturduğunuz Ölçümler</h3>
                <table border="1" cellPadding="5" style={{borderCollapse:'collapse'}}>
                  <thead><tr><th>ID</th><th>Subject</th><th>Description</th><th>LSL</th><th>USL</th><th>Birim</th></tr></thead>
                  <tbody>
                    {myMeasurements.map((m)=>(
                      <tr key={m.id}><td>{m.id}</td><td>{m.subject}</td><td>{m.description}</td>
                        <td>{m.lsl}</td><td>{m.usl}</td><td>{m.measurementUnit}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        {/* ===== ANALYSIS PAGE ===== */}             {/* NEW */}
        {activePage==='analysis' && <AnalysisPanel/>}

        {statusMessage&&<div style={{marginTop:'20px',color:'blue'}}>{statusMessage}</div>}
      </div>{/* content */}
    </div>
  );
}

/* ==================================================
 * EXPORT – ToastProvider ile sarmalanmış kök
 * ================================================== */
export default function App(){
  return(
    <ToastProvider>
      <InnerApp/>
     
     
     <ProcessReportButton/>   {/*  ⇐ turuncu PDF simgesi artık buraya çizilir */}
    </ToastProvider>
  );
}